export const API_CODES = {
  ERROR: 1,
  NO_DATA: 2,
  SUCCESS: 3,
};
